import { BookingI } from '../bookings/Booking';
import { ApiAttachment } from '../MainFiles';

declare type BookingIndexI = number;
interface AttBookingIndexesI {
  [partId: string]: {
    [pageNum: number]: BookingIndexI[]; // has to use booking index instead of bookingNo to cover the duplicate and blank cases
  };
}

class AttPageSelected {
  attBookingIndexes;
  constructor(atts: ApiAttachment[], curBookings: BookingI[]) {
    this.attBookingIndexes = this._getAttBookingIndexes(
      atts,
      curBookings,
    );
  }

  private _getAttBookingIndexes(
    atts: ApiAttachment[],
    bookings: BookingI[],
  ): AttBookingIndexesI {
    return atts.reduce((acc, att) => {
      acc[att.partId] = att.pages.reduce((pageAcc, page) => {
        pageAcc[page.num] = bookings
          .map((booking, i): number | boolean => {
            if (booking.fileSelected) {
              const matched = booking.fileSelected.some((eachFS) => {
                return eachFS.pages.some(
                  (p) =>
                    p.partId === att.partId && p.pageNo === page.num,
                );
              });
              return matched && i;
            }
            return false;
          })
          .filter((index) => typeof index === 'number');
        return pageAcc;
      }, {});
      return acc;
    }, {});
  }

  /**
   * green border
   * @param partId
   * @param pageNum
   * @param bookingIndex
   */
  public isAttPageInBookingFileSelected(
    partId: string,
    pageNum: number,
    bookingIndex: number,
  ): boolean {
    return (
      (this.attBookingIndexes[partId] &&
        this.attBookingIndexes[partId][pageNum] &&
        this.attBookingIndexes[partId][pageNum].includes(
          bookingIndex,
        )) ||
      false
    );
  }

  /**
   * grey cover (in other booking)
   * @param partId
   * @param pageNum
   * @param bookingIndex
   */
  public isAttPageInOtherFileSelected(
    partId: string,
    pageNum: number,
    bookingIndex: number,
  ): boolean {
    return (
      (this.attBookingIndexes[partId] &&
        this.attBookingIndexes[partId][pageNum] &&
        this.attBookingIndexes[partId][pageNum].length > 0 &&
        this.attBookingIndexes[partId][pageNum].some(
          (bI) => bI !== bookingIndex,
        )) ||
      false
    );
  }
}

export { AttPageSelected };
